import { render, staticRenderFns } from "./VoucherUsage.vue?vue&type=template&id=61a63356&scoped=true"
import script from "./VoucherUsage.vue?vue&type=script&lang=js"
export * from "./VoucherUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a63356",
  null
  
)

export default component.exports